import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Close } from '@mui/icons-material';
import { styled } from "@mui/material/styles";
import MoreVert from '@mui/icons-material/MoreVert';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Button,
    Menu,
    MenuItem,
    Grid,
    Card,
    CardHeader,
    Divider,
    CardContent,
    Avatar
} from '@mui/material';
import { axiosFetch } from '../../../../utils/AxiosFetch';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import { deleteComment } from '../../../../redux/actions/deleteComments.action';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { SnackbarActions } from '../../../../redux/actions/snackbar.actions';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    // ValidatorForm.addValidationRule("")
    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ViewComments = (props) => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    let krId = props && props.krId !== '' ? props.krId : null;
    const [open, setOpen] = React.useState(props && props.open);
    const [commentsList, setCommentsList] = useState([]);
    const [comment_anchorEl, setComment_AnchorEl] = React.useState(null);
    const comment_open = Boolean(comment_anchorEl);
    const [selectedCommentId, setSelectedCommentId] = useState("");
    const [openDialog, setOpenDialog] = useState(false);

    const loadComments = (id) => {
        axiosFetch({
            method: "get",
            url: `/OKRs/okr/comments/${id}`
        })
            .then((res) => {
                if (res.status === 200) {
                    setCommentsList(res.data);
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })

            .catch((err) => console.error(err));
    }

    const handleClick_comment = (event, id) => {
        setSelectedCommentId(id);
        setComment_AnchorEl(event.currentTarget);
    };

    const openConfirmPopup = () => {
        setOpenDialog(true);
    };

    const handleClose_comment = () => {
        setComment_AnchorEl(null);
    };

    const handleDelete = () => {
        dispatch(deleteComment(selectedCommentId));
        setOpenDialog(false);
        // window.location.reload();
    }

    const addNewComment = () => {

        props.toggleCommentsPopup(krId);
        loadComments(krId);
    }

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        loadComments(krId);
    }, [])
    return (
        <div>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth="sm"
                onClose={() => props.toggleViewComments(false)}
                maxWidth="sm"
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={() => props.toggleViewComments(false)}
                    className="modal-heading"
                >
                    Comments
                </BootstrapDialogTitle>

                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button className='theme-btn' style={{ marginBottom: "15px" }} onClick={addNewComment}>Add Comment</Button>
                        </Grid>
                    </Grid>

                    {
                        commentsList.map((comments) => (
                            <Card sx={{ position: "relative", padding: "10px", marginBottom: "20px" }}>
                                <CardHeader avatar={<Avatar aria-label="recipe">
                                    <Link to={`/users-profile/${comments.createdBy}`}> {comments.createdByName !== null ? comments.createdByName.charAt(0) : ""}</Link>
                                </Avatar>}
                                    action={<MoreVert className="card-option-kr" onClick={(e) => handleClick_comment(e, comments.id)} />}
                                    title={comments.createdByName !== null ? <Link className="comment-created" to={`/users-profile/${comments.createdBy}`}>{comments.createdByName}</Link> : ""}
                                    subheader={comments.createdDate !== null ? "created at " + moment(comments.createdDate).format('DD-MMM-YYYY') : ""}
                                />
                                <Divider />
                                <CardContent sx={{ marginTop: "10px" }} className="stensil-ignore">{comments.comment !== null ? comments.comment : null}</CardContent>
                            </Card>

                        ))
                    }
                </DialogContent>

            </BootstrapDialog >

            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={comment_anchorEl}
                open={comment_open}
                onClose={handleClose_comment}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >

                <MenuItem> <IconButton onClick={openConfirmPopup}>
                    <IconButton onClick={handleDelete}>
                        <DeleteIcon /> Delete
                    </IconButton>

                </IconButton></MenuItem>
            </Menu>
        </div >
    )
}

export default ViewComments;